import axios from 'axios';
import { APIURL, TZ } from '../../../Global';

export const sampleList = ["blood", "urine", "serum", "sputum", "plasma", "semen", "csf", "feces", "saliva", "pus specimen", "body fluid specimen", "amniotic fluid specimen", "urethral fluid", "vaginal fluid", "tissue", "nasopharyngeal swab", "cervical swab", "skin", "others"];
export const list = ['ModernMedicine', 'Ayurveda', 'Homeopathy', 'Unani', 'Dental', 'Multispeciality', 'Other'];

export let testGroupsList = [];
export const fetchTestGroups = async () => {
    try {
        const tokenString = sessionStorage.getItem('usertoken');
        if (!tokenString) {
            throw new Error('No token found');
        }

        const str = tokenString.replace(/["]+/g, '');
        const response = await axios.get(`${APIURL}/api/v1/staff/master-test-group/?test_group=true`, {
            headers: {
                Authorization: 'Token ' + str,
            },
        });

        if (response.status === 200 && response.data.status === 'success') {
            testGroupsList = response.data.master_test_group?.map((group) => ({
                value: group.id,
                label: group.group_name,
            })) || [];

            return testGroupsList;
        } else {
            throw new Error(response.data.message || 'Error fetching test groups');
        }
    } catch (error) {
        console.error('Error fetching test groups:', error);
        throw error;
    }
};

